import axios from '@/store/config';
import auth from '@/auth/index';

export default {
  state : {
    ///appErrors : [],
    isLoggedIn : false
  },
  actions : {
    // pushToErrors({ commit, state }, error){
    //   commit('pushToErrors', error);
    // },
    // clearErrors({ commit, state }){
    //   state.appErrors.splice(0, state.appErrors.length)
    // }
  },
  getters : {
    //appErrors: state => state.appErrors,
    isLoggedIn: state => state.isLoggedIn
  },
  mutations : {

    // pushToErrors(state, error){
    //   if(state.appErrors.indexOf(error) == -1)
    //     state.appErrors.push(error);
    // }
  }
}
